import pubicGetters from "../publicModule/pubicGetters";
export default {
  ...pubicGetters
}
